import React from "react";
import { IconButton, Tooltip } from '@material-tailwind/react';
import { HiPencil, HiOutlineChevronRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

export default function TimeRangeGrid({ timeRanges, startTime = 0, endTime = 24, isAdmin }) {

    const totalHours = endTime - startTime;
    const gridTemplateColumns = `repeat(${totalHours}, 1fr)`;
    const navigate = useNavigate();

    return (

        <div className="time-range-grid" style={{ gridTemplateColumns }}>
            {[...Array(totalHours)].map((_, index) => (
                <div key={index} className="time-slot">
                    {startTime + index}:00
                </div>
            ))}
            {timeRanges.map(({ start, end, booking }, index) => (
                <div
                    key={index}
                    className="booking"
                    style={{
                        gridColumn: `${start - startTime + 1} / ${end - startTime + 1}`,
                        backgroundColor: `hsl(${index * 60}, 70%, 80%)`,
                    }}
                >
                    <Tooltip
                        animate={{
                            mount: { scale: 1, y: 0 },
                            unmount: { scale: 0, y: 25 },
                        }}
                        content={<div className="flex flex-start flex-wrap font-bold">
                            <div className="flex w-full ">
                                <span className="font-semibold px-2">Guest:</span>
                                <span>{booking.guestName} ({booking.guestMobile})</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">CheckIn:</span>
                                <span>{booking.checkInDateTime}</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Checkout:</span>
                                <span>{booking.checkOutDateTime}</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Days:</span>
                                <span>{booking.numberOfDays}</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Advance:</span>
                                <span>₹{booking.advancePayment || 0}.00 ({booking.paymentMode || "NA"})</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Payment Date:</span>
                                <span>{booking.paymentDate || ""}</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Pending:</span>
                                <span>₹{booking.pendingAmount}.00</span>
                            </div>
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Status:</span>
                                <span>{booking.bookingStatus}</span>
                            </div>
                            {booking.roomBookings.map((room, index) => (
                                <div key={index} className="flex w-full">
                                    <span className="font-semibold px-2">{room.category}: </span>
                                    <span> {room.numberOfRooms}</span>
                                </div>
                            ))}
                            <div className="flex w-full">
                                <span className="font-semibold px-2">Notes:</span>
                                <span>{booking.notes}</span>
                            </div>
                        </div>} >


                        <div className={`flex flex-start flex-wrap font-normal ${booking.bookingStatus === "COMPLETED" ? "line-through text-gray-700" : ""}`}>
                            <div className="px-1 py-1">
                                <span className="font-semibold px-2">Guest:</span>
                                <span>{booking.guestName} ({booking.guestMobile})</span>
                            </div>
                            <IconButton size="md" onClick={() => navigate(`/manager/bookings/edit/${booking.guestMobile}/${booking.bookingId}/${booking.bookingStatus}`)}>
                                {isAdmin ? <HiPencil className="h-6 w-6" /> : <HiOutlineChevronRight className="h-6 w-6" />}
                            </IconButton>
                            <div className="px-1 py-1">
                                <span className="font-semibold px-2">Period:</span>
                                <span>{booking.checkInDateTime} - {booking.checkOutDateTime}</span>
                            </div>
                            <div className="px-1 py-1">
                                <span className="font-semibold px-2">Advance Payment:</span>
                                <span>₹{booking.advancePayment} ({booking.paymentMode})</span>
                            </div>
                            {booking.roomBookings.map((room, index) => (
                                <div key={index} className="px-1 py-1">
                                    <span className="font-semibold px-2">{room.category}: </span>
                                    <span> {room.numberOfRooms}</span>
                                </div>
                            ))}
                        </div>
                    </Tooltip>
                </div>
            ))}
            {timeRanges.length === 0 && <div className="col-span-full">No bookings</div>}
        </div>
    );
};